export default __webpack_public_path__ + "static/media/graph1.6d43d6c7.png";